import palette from "../palette";

export default {
  root: {
    border: `0.8px solid ${palette.secondary.main}`,
    borderRadius: "unset",
    background: "#ffffff26",
    height: "54px",
    color: palette.secondary.main,
  },
  notchedOutline: {
    borderColor: "rgba(0,0,0,0.15)",
  },
};
